import { __assign } from '../../../../../../../../node_modules/tslib/tslib.es6.js';
import { Box, Typography } from '@mui/material';
import React__default, { useState, useEffect } from 'react';
import { StyledZigSlider, Value } from './styles.js';
import { useTranslation } from 'react-i18next';

var SliderFilter = function (_a) {
    var filter = _a.filter, onChange = _a.onChange;
    var label = filter.label, value = filter.value, _b = filter.min, min = _b === void 0 ? 0 : _b, _c = filter.max, max = _c === void 0 ? 100 : _c, _d = filter.step, step = _d === void 0 ? 1 : _d, _e = filter.allowNoMin, allowNoMin = _e === void 0 ? false : _e, _f = filter.allowNoMax, allowNoMax = _f === void 0 ? false : _f, id = filter.id, _g = filter.showPct, showPct = _g === void 0 ? true : _g;
    var t = useTranslation("zignaly-ui", { keyPrefix: "ZigFilters" }).t;
    var _h = useState(value), internalValue = _h[0], setInternalValue = _h[1];
    var sliderValue = Array.isArray(internalValue)
        ? [
            internalValue[0] === null ? min - step : internalValue[0],
            internalValue[1] === null ? max + step : internalValue[1],
        ]
        : internalValue;
    useEffect(function () {
        if (value !== internalValue) {
            setInternalValue(value);
        }
    }, [value]);
    var adaptMin = function (value) {
        if (value < min)
            return null;
        if (value > max)
            return max;
        return value;
    };
    var adaptMax = function (value) {
        if (value > max)
            return null;
        if (value < min)
            return min;
        return value;
    };
    var adaptValue = function (value) {
        return Array.isArray(value) ? [adaptMin(value[0]), adaptMax(value[1])] : value;
    };
    return (React__default.createElement(Box, null,
        label && (React__default.createElement(Typography, { component: "div", pb: 1, id: "filter-slider-".concat(id, "__label") }, label)),
        React__default.createElement(StyledZigSlider, { value: sliderValue, min: allowNoMin ? min - step : min, max: allowNoMax ? max + step : max, onChange: function (_, v) { return setInternalValue(adaptValue(v)); }, onChangeCommitted: function (_, v) { return onChange(__assign(__assign({}, filter), { value: adaptValue(v) })); }, marks: false, valueLabelDisplay: "off", labels: { showValues: false } }),
        React__default.createElement(Box, { display: "flex", justifyContent: "center", pt: 1, gap: "6px" }, Array.isArray(internalValue) ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Value, { showPct: showPct && internalValue[0] !== null, id: "filter-slider-".concat(id, "__value-1") }, internalValue[0] === null ? t("min", { defaultValue: "Min" }) : internalValue[0]),
            React__default.createElement(Typography, { fontSize: 15 }, t("to", { defaultValue: "to" })),
            React__default.createElement(Value, { showPct: showPct && internalValue[1] !== null, id: "filter-slider-".concat(id, "__value-2") }, internalValue[1] === null ? t("max", { defaultValue: "Max" }) : internalValue[1]))) : (React__default.createElement(Value, { showPct: showPct }, internalValue)))));
};

export { SliderFilter as default };
